<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account-clock-outline
      </v-icon> Staff Check-Out
    </h2>
    <br>
    <v-card color="#CFD8DC">
      <div class="steps-style">
        <p><span :style="step1Success">Location Verification</span> -> Check-Out</p>
      </div>
      <hr>
      <v-stepper
        v-model="userCheckOut"
        light
        class="my-stepper-style"
      >
        <v-stepper-header>
          <v-stepper-step
            :complete="userCheckOut > 1"
            step="1"
            color="#FF3700"
          />

          <v-divider />

          <v-stepper-step
            :complete="userCheckOut > 2"
            step="2"
            color="#FF3700"
          />
        </v-stepper-header>
      </v-stepper>
      <div>
        <staff-loc-verification
          v-if="showLocationVerificationPage"
          @verification-completed="toSecondStep"
        />
        <staff-checkout
          v-if="showStaffCheckOutPage"
          @checkout-completed="checkOutCompleted"
        />
      </div>
    </v-card>
  </v-container>
</template>
<script>
import StaffLocVerification from './StaffLocVerification.vue';
import StaffCheckOut from './StaffCheckOut.vue';

export default {
  name: 'StaffCheckOutLanding',
  components: {
    'staff-loc-verification': StaffLocVerification,
    'staff-checkout': StaffCheckOut,
  },
  data () {
    return {
      userCheckOut: 1,
      showLocationVerificationPage: true,
      step1SuccessColor: '',
      showStaffCheckOutPage: false,
    };
  },
  computed: {
    step1Success () {
      return `color:${this.step1SuccessColor}`;
    },
  },
  async mounted () {
    await this.fetchActiveCheckInDetails();
  },
  methods: {
    async fetchActiveCheckInDetails () {
      this.loading = true;
      const checkInId = localStorage.getItem('checkIn');
      this.$store.dispatch('swiftuser/fetchActiveCheckInDetails', {
        checkInId: checkInId,
      }).then(response => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$router.push({ name: 'HomePage' });
      });
    },
    toSecondStep () {
      this.step1SuccessColor = '#00796B';
      this.userCheckOut = 2;
      this.showLocationVerificationPage = false;
      this.showStaffCheckOutPage = true;
    },
    checkOutCompleted () {
      this.$router.push({ name: 'HomePage' });
    },
  },
};
</script>
<style scoped>
.my-stepper-style {
  background-color: #CFD8DC;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.steps-style {
  text-align: center;
  padding-top: 25px;
  color: #37474F;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-weight: 500;
  font-size: 14px;
}
</style>
